import { ActionReducerMap } from '@ngrx/store';
import { BrandPLPPageState } from './state';
import { productsReducer } from './products';
import { brandInfoReducer } from './brand-info';
import { sortReducer } from './sort';

export const brandPLPReducers: ActionReducerMap<BrandPLPPageState> = {
  products: productsReducer,
  brandInfo: brandInfoReducer,
  sort: sortReducer
};
